/**
 * `createEl(tag, props, children)` — DOM builder, который по умолчанию рендерит
 * БЕЗОПАСНО: каждый строковый child становится текстовым узлом (`textContent`,
 * никогда `innerHTML`). Пользовательский контент никогда не попадает в DOM как HTML.
 *
 * Props:
 *   className     → el.className
 *   dataset       → Object.assign(el.dataset, …)
 *   onX           → el.addEventListener(x.toLowerCase(), …)
 *   <anything>    → el.setAttribute(<anything>, value)
 *
 * Children: string | Element | null | false | массив любого из перечисленного.
 * Null / false пропускаются (условный рендеринг). Массивы разворачиваются на один уровень.
 */
export function createEl(tag, props = {}, children = []) {
    const el = document.createElement(tag);
    for (const [k, v] of Object.entries(props)) {
        if (v == null) continue;
        if (k === 'className') {
            el.className = v;
        } else if (k === 'dataset') {
            Object.assign(el.dataset, v);
        } else if (k.startsWith('on') && typeof v === 'function') {
            el.addEventListener(k.slice(2).toLowerCase(), v);
        } else {
            el.setAttribute(k, String(v));
        }
    }
    const flat = Array.isArray(children) ? children.flat() : [children];
    for (const child of flat) {
        if (child == null || child === false) continue;
        el.append(typeof child === 'string' ? document.createTextNode(child) : child);
    }
    return el;
}

/**
 * Удаляет все дочерние узлы. Дешевле, чем `el.innerHTML = ''` в плотных
 * циклах; итоговое состояние эквивалентно.
 */
export function clearChildren(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
}
